import { LinkedIn } from '@mui/icons-material';
import DeepShikha from '../../Media/Team/DeepShikha-managingDirector.png';
import lalanAdviser from '../../Media/Team/lalan-advisory.jpg';
import SaurabhAdviser from '../../Media/Team/Saurabh-advisory.png';
import ChandanAdviser from '../../Media/Team/Chandan-advisory.png';
import amitKumar from '../../Media/Team/amitKumar.jpeg';
import ravi from '../../Media/Team/ravi.png';
import ishan from '../../Media/Team/ishan.jpeg';
import harsh from '../../Media/Team/harsh.jpg';
import ajay from '../../Media/Team/ajaymundera.jpeg';
import lakshya from '../../Media/Team/lakshya.jpeg';
export function TeamMembers() {
	const Members = [
		{
			name: 'Harsh Agarwal',
			designation: 'Team Lead',
			image: harsh,
			linkedIn: 'https://www.linkedin.com/in/harsh-agarwal-2b7654237/',
		},
		{
			name: 'Ishan Arya',
			designation: 'Developer',
			image: ishan,
			linkedIn: 'https://www.linkedin.com/in/ishan-arya-339354280/',
		},
		{
			name: 'Ravi Kumawat',
			designation: 'Developer',
			image: ravi,
			linkedIn: 'https://www.linkedin.com/in/ravi-kumawat-5406342a1/',
		},
		{
			name: 'Ajay Mundera',
			designation: 'Developer',
			image: ajay,
			linkedIn: 'https://www.linkedin.com/in/ajaymundera/',
		},
		{
			name: 'Lakshya Kumar',
			designation: 'Marketing Lead',
			image: lakshya,
			linkedIn: 'https://www.linkedin.com/in/lakshya-kumar-7b00a8419',
		},
	];

	return (
		<div
			id='card-container'
			className='min-h-96 w-full max-w-[860px] mx-auto flex justify-center items-center lg:p-5 lg:gap-5 gap-4 flex-wrap'
		>
			{Members.map((member, key) => (
				<div
					key={key}
					className='team-member-card lg:min-h-[21rem] lg:h-auto lg:w-64 min-h-[18rem] h-auto w-56 bg-zinc-200 flex flex-col gap-3 justify-start items-center p-3 rounded-2xl'
				>
					<div className='profile-container lg:w-44 lg:h-44 w-32 h-32 rounded-full overflow-hidden border-black border-1 flex-shrink-0'>
						<img src={member.image} alt='Profile' className='w-full h-full object-cover' />
					</div>
					<div id='description' className='w-full min-h-20 h-auto flex flex-col justify-center items-center gap-1 mt-3'>
						<span className='text-xl'>
							<b>{member.name}</b>
						</span>
						<span className='font-roboto'>{member.designation}</span>
						<a href={member.linkedIn} target='_blank' rel='noreferrer' className='text-white' onMouseEnter={(e) => e.stopPropagation()}>
							<LinkedIn
								sx={{
									'fontSize': 30,
									'color': 'black', // Default color
									'transition': 'transform 0.3s ease, color 0.3s ease', // Smooth transition for both transform and color
									'&:hover': {
										color: '#70BFF3', // Hover color
										transform: 'scale(1.2)', // Scale up on hover
									},
								}}
							/>
						</a>
					</div>
				</div>
			))}
		</div>
	);
}

export function Founders() {
	const founders = [
		{
			name: 'Dr. Lalan Kumar',
			designation: 'Founder',
			image: lalanAdviser,
			linkedIn: '',
		},
		{
			name: 'Deepshikha',
			designation: 'Managing Director',
			image: DeepShikha,
			linkedIn: '',
		},
	];

	return (
		<div
			id='card-container'
			className='min-h-96 w-full  flex justify-center items-center lg:p-5 lg:gap-5 gap-4 flex-wrap'
		>
			{founders.map((member, key) => (
				<div
					key={key}
					className='team-member-card lg:min-h-[21rem] lg:h-auto lg:w-64 min-h-[18rem] h-auto w-56 bg-zinc-200 flex flex-col gap-3 justify-start items-center p-3 rounded-2xl'
				>
					<div className='profile-container lg:w-44 lg:h-44 w-32 h-32 rounded-full border-black border-1 overflow-hidden flex-shrink-0'>
						<img src={member.image} alt='Profile' className='w-full h-full object-cover' />
					</div>
					<div id='description' className='w-full h-20 flex flex-col justify-center items-center gap-1 mt-3'>
						<span className='font-bold text-2xl'>{member.name}</span>
						<span className='font-normal'>{member.designation}</span>
						<a href={member.linkedIn} target='_blank' rel='noreferrer' className='text-white' onMouseEnter={(e) => e.stopPropagation()}>
							<LinkedIn
								sx={{
									'fontSize': 30,
									'color': 'black', // Default color
									'transition': 'transform 0.3s ease, color 0.3s ease', // Smooth transition for both transform and color
									'&:hover': {
										color: '#70BFF3', // Hover color
										transform: 'scale(1.2)', // Scale up on hover
									},
								}}
							/>
						</a>
					</div>
				</div>
			))}
		</div>
	);
}

export function AdvisoryTeam() {
	const advisors = [
		{
			name: 'Saurabh Singh',
			image: SaurabhAdviser,
			description:
				'Mr. Saurabh Singh is working as director of credit at Trifecta Capital. He had been the co-founder of Intellinovate Solutions, Crispy Tokri, and Clove Dental. He is an alumnus of IIT BHU and IIM Ahmedabad.',
		},
		{
			name: 'Chandan Kumar',
			image: ChandanAdviser,
			description:
				'Mr. Chandan Kumar is working with Tata Steel as senior planning manager. He is an alumnus of IIT BHU and IIM Ahmedabad.',
		},
		{
			name: 'Amit Kumar',
			image: amitKumar,
			description:
				'Amit Kumar is a PMRF Ph.D. in the area of Cognitive Neuroscience and Meditation. He holds an M. Tech from IIT Delhi, MA in Philosophy, MA in Psychology from DU, and B. Tech from NIT Calicut. He is State Head of "TheSatyarthFoundation” and author of Indian express newspaper.',
		},
	];

	return (
		<div id='card-container' className=' w-full flex justify-center items-center lg:p-5 lg:gap-5 gap-4 flex-wrap'>
			{advisors.map((adviser, key) => (
				<div
					key={key}
					className='team-member-card lg:min-h-[27rem] lg:h-auto lg:w-72 min-h-[26rem] h-auto w-56 bg-zinc-200 flex flex-col gap-3 justify-start items-center p-3 rounded-2xl'
				>
					<div className='profile-container lg:w-44 lg:h-44 w-32 h-32 rounded-full border-black border-1 overflow-hidden flex-shrink-0'>
						<img src={adviser.image} alt='Profile' className='w-full h-full object-cover' />
					</div>
					<div id='description' className='w-full flex flex-col justify-center items-center mt-2 gap-1'>
						<span className='font-bold text-2xl'>{adviser.name}</span>
						<span className='font-light text-sm text-center'>{adviser.description}</span>
					</div>
				</div>
			))}
		</div>
	);
}
